import "./App.css";
import React, { Suspense, useRef, useEffect, useState } from "react";
import { BrowserRouter, useNavigate } from "react-router-dom";
import { message } from "antd";
import "./notification";
import commonObj from "./commonObj";
import service from "./services/auth";
import serviceConstatnt from "./services/constant";

import { Spin } from "antd";
import Loader from "./views/components/loader";
import SiteLoader from "./views/components/SiteLoader";

Spin.setDefaultIndicator(
  <div>
    <Loader />
  </div>
);

const LayoutAdmin = React.lazy(() => import("./views/layout/Layout"));
const Login = React.lazy(() => import("./views/pages/Login"));

function AppContent() {
  const navigate = useNavigate();
  const [isLoggedin, setIsLoggedin] = useState(false);
  const [ajxRequesting, setAjxRequesting] = useState(false);

  const didRun = useRef(false);

  useEffect(() => {
    if (didRun.current) return;
    didRun.current = true;

    setAjxRequesting(true);

    const fetchConstants = () =>
      serviceConstatnt.getConstant().then((res) => {
        commonObj.constants = res?.data || {};
      });

    const validateToken = () =>
      service.validateToken().then((res) => {
        commonObj.userType = res?.data?.role || "";
        // You can store more fields if needed:
        // commonObj.firstName = res?.firstName || "";
        // commonObj.avatar    = res?.avatar || "";
      });

    Promise.all([fetchConstants(), validateToken()])
      .then(() => {
        setIsLoggedin(true);
        message.success("Welcome back!");
        // ← Redirect here after successful auto-login (token valid)
        navigate("/user-management", { replace: true });
      })
      .catch((err) => {
        console.error("Initialization failed:", err);
        setIsLoggedin(false);
        window.localStorage.clear();
        // message.error("Session expired. Please login again.");
      })
      .finally(() => {
        setAjxRequesting(false);
      });
  }, [navigate]);

  // This component handles redirection after manual login
  const handleLoginSuccess = () => {
    setIsLoggedin(true);
    message.success("Login successful!");
    navigate("/user-management", { replace: true });
  };

  if (ajxRequesting) {
    return <SiteLoader />;
  }

  return isLoggedin ? (
    <Suspense fallback={<SiteLoader />}>
      <LayoutAdmin />
    </Suspense>
  ) : (
    <Suspense fallback={<SiteLoader />}>
      <Login onLoginSuccess={handleLoginSuccess} />
    </Suspense>
  );
}

function App() {
  return (
    <BrowserRouter basename="/">
      <AppContent />
    </BrowserRouter>
  );
}

export default App;